var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.open,"color":"green","bottom":"","outlined":"","timeout":10000}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.onConfirmed()}}},[_vm._v("OK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }